import { IResolvedClassicReview } from '@/src/utils/collections/review.mapper';
import { StarRating } from '@/src/components/star-rating/StarRating';
import { DownloadButtons } from '@/src/components/ui/DownloadButtons/DownloadButtons';

export const ReviewClassic = ({
  description,
  nbReviews,
  rating,
  downloadsSince,
  nbDownloads,
  linkToPlayStore,
  linkToAppStore,
}: IResolvedClassicReview) => {
  return (
    <div className={'mx-auto max-w-1200 px-4'}>
      <div
        className={
          'flex-row justify-between rounded-3xl bg-overlay p-8 lg:flex lg:gap-24 lg:px-[100px] lg:py-10'
        }
      >
        <div>
          <div className={'grid grid-cols-2 justify-between space-x-8'}>
            <div>
              <p className={'mb-3 text-6xl font-semibold'}>{nbDownloads}</p>
              <p>{downloadsSince}</p>
            </div>
            <div>
              <p className={'mb-4 text-6xl font-semibold'}>{rating}</p>
              <StarRating rating={rating} size={17} />
              <p>{nbReviews}</p>
            </div>
          </div>
          <div className={'[&_div]:justify-between'}>
            <DownloadButtons
              linkToAppStore={linkToAppStore}
              linkToPlayStore={linkToPlayStore}
            />
          </div>
        </div>
        <div
          className={
            'mt-14 text-3xl font-semibold lg:mt-0 lg:max-w-xl lg:text-4xl'
          }
        >
          {description}
        </div>
      </div>
    </div>
  );
};
